import { useMemo } from 'react';
import { hex } from 'wcag-contrast';

import useDebounce from './useDebounce';

export default function useColorContrast({
  foregroundColor = '',
  backgroundColor = '#ffffff',
  delay = 100
}) {
  const color = useDebounce(foregroundColor, delay);
  const bgColor = useDebounce(backgroundColor, delay);

  const contrastRatio = useMemo(() => {
    if (!color || !bgColor) {
      return null;
    }

    return hex(bgColor, color).toFixed(2);
  }, [color, bgColor]);

  return contrastRatio;
}
